<template>
  <transition name="modal-fade">
    <span v-show="isModalVisible">
      <div class="modal" role="dialog">
        <header class="modal-header">
          <slot name="header">
            {{ i18nJS.user_bu_absences.massive_import_absences }}
            <button type="button" class="btn-close" @click="close" aria-label="Close modal">
              <i class="fa-light fa-xmark"></i>
            </button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <div>
              <label>
                File
                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
              </label>
            </div>
            <div class="alert">
              <span class="closebtn fa-light fa-triangle-exclamation">&nbsp;</span>
              <strong>{{ i18nJS.warning_label }}!</strong>
              {{ i18nJS.user_bu_absences.warning }}
            </div>
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-primary secondary" @click="close" aria-label="Close modal">
              {{ i18nJS.command.close }}
            </button>
            <button type="button" class="btn btn-success" aria-label="Save modal" @click="saveAbsences">{{ i18nJS.command.load }}</button>
          </slot>
        </footer>
      </div>
      <div class="modal-backdrop"></div>
    </span>
  </transition>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import axios from 'axios';
export default {
  name: 'massiveImportsAbsences',
  props: ['targetModal'],
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  data() {
    return {
      loading: false,
      isModalVisible: false,
      file: null,
      url: '/it/user_bu_absences/import_absences',
      calendar: $('#calendar_absences'),
    };
  },
  mounted() {
    $(`[data-toggle='import-absences'], [data-target='${this.targetModal}']`).click(() => {
      this.isModalVisible = true;
    });
  },
  methods: {
    close() {
      //this.$emit('close');
      this.isModalVisible = false;
    },

    updateCalendarEvents() {
      //this.$emit('close');
      axios
        .get('/it/user_bu_absences/get_absences', {
          responseType: 'json',
          params: { start: '2019-02-01', end: '2019-02-28' },
        })
        .then((response) => {
          this.calendar.fullCalendar({ eventSources: response.data });
          this.calendar.fullCalendar('refetchEvents');
          this.calendar.fullCalendar('rerenderEvents');
        })
        .catch((error) => {
          console.log('error ' + error);
        });
    },

    saveAbsences() {
      let formData = new FormData();
      formData.append('file', this.file);
      if (this.file != null) {
        //Loader.show();
        apiConnector()
          .post(this.url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then((params) => {
            this.calendar.fullCalendar('refetchEvents');
            this.calendar.fullCalendar('rerenderEvents');
            this.close();
          })
          .catch(() => {
            //Loader.hide();
            this.error = true;
          });
      }
    },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
};
</script>
<style lang="scss" scoped>
.vmodal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  left: 25%;
  width: 50%;
  margin-left: 0;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}
.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}
.modal-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
  color: #ef7b12;
  justify-content: space-between;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}
.modal-body {
  position: relative;
  padding: 20px 10px;
}
.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #ef7b12;
  background: transparent;
}
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
.graycolor {
  color: #999;
}
.blackcolor {
  color: #0000;
}
</style>
